import { ActionTypes } from './actionTypes';

export const setStoreIncome = (payload) => ({
  type: ActionTypes.SET_STORE_INCOME,
  payload,
});
